"use strict";

define('view/list.pagination',['require','exports','module','marionette','enquire','uikit/uikit','../templates','langs'],function (require, exports, module) {
  'use strict';

  var Mn = require('marionette');
  var enquire = require('enquire');
  var UIKit = require('uikit/uikit');
  var Templates = require('../templates');
  var langs = require('langs');
  var ListPaginationView = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    className: 'irb list pagination',
    template: Templates.IRB['list.pagination'],
    tagName: 'nav',
    attributes: {
      'aria-label': langs.phrase('Pagination.ARIALabel')
    },
    internalViews: {
      pageSizeDropdown: UIKit.Dropdown,
      pageNumbers: UIKit.Pagination,
      title: UIKit.Text
    },
    internalViewOptions: {
      pageSizeDropdown: {
        mode: 'select',
        search: false,
        direction: 'up'
      },
      pageNumbers: {
        pageShowAmount: 5,
        alwaysShowEnds: true,
        ariaLabel: 'select a page'
      },
      title: {
        attributes: {
          role: 'alert',
          'aria-live': 'assertive',
          'aria-atomic': 'true'
        }
      }
    },
    options: {
      responsive: false,
      enquireQuery: 'screen and (max-width: 1400px)',
      enquireResponse: null
    },
    initialize: function initialize() {
      UIKit.ComponentMixin.initialize.apply(this, arguments);
      this.on('title:before:render', function (titleView) {
        titleView.updateElementAttributes({
          'aria-label': 'currently showing items ' + titleView.text + ' total items',
          tabindex: '0'
        });
      });
      this.on('pageSizeDropdown:before:render', function (pageSizeDropdownView) {
        pageSizeDropdownView.ariaLabel = 'number of items to show per page, currently showing ' + pageSizeDropdownView.text;
      });
      var self = this;
      this.enquireResponse = {
        match: function match() {
          self.responsive = true;
        },
        unmatch: function unmatch() {
          self.responsive = false;
        }
      };
      enquire.register(this.enquireQuery, this.enquireResponse);
    },
    onDestroy: function onDestroy() {
      enquire.unregister(this.responsiveTrigger, this.enquireResponse);
    }
  });
  return ListPaginationView;
});

